import { BezierLine } from '@model-framework/link/BezierLine/BezierLine';
import type { Point } from '@view-model/models/common/basic';

export const straightBezier = (start: Point, end: Point): BezierLine =>
  new BezierLine(start, start.interpolated(end, 0.5), end);
